export default {
    title: {
        ru: 'Отчёты',
        en: 'Reports',
    },
    create: {
        ru: 'Создать отчёт',
        en: 'Create report',
    },
    selectGenerator: {
        ru: 'Выберите генератор',
        en: 'Select a generator',
    },
    unknownGenerator: {
        ru: 'Недоступный генератор',
        en: 'Unavailable generator',
    },
    placeholder: {
        ru: 'Нет данных',
        en: 'Not available',
    },
    fields: {
        name: {
            ru: 'Название',
            en: 'Name',
        },
        orders: {
            ru: 'Заказы',
            en: 'Orders',
        },
    },
    columns: {
        name: {
            ru: 'Название',
            en: 'Name',
        },
        generator: {
            ru: 'Генератор',
            en: 'Generator',
        },
        orders: {
            ru: 'Номера заказов',
            en: 'Orders',
        },
        order: {
            ru: 'Заказ',
            en: 'Order',
        },
        status: {
            ru: 'Статус',
            en: 'Status',
        },
        createdAt: {
            ru: 'Создан',
            en: 'Created',
        },
        updatedAt: {
            ru: 'Обновлён',
            en: 'Updated',
        },
        actions: {
            ru: 'Действия',
            en: 'Actions',
        },
    },
    statuses: {
        queued: {
            ru: 'В очереди',
            en: 'Queued',
        },
        processing: {
            ru: 'Формируется',
            en: 'Processing',
        },
        ready: {
            ru: 'Готов',
            en: 'Ready',
        },
        failed: {
            ru: 'Не удалось сформировать',
            en: 'Failed',
        },
    },
    empty: {
        ru: 'Отчётов пока нет',
        en: 'No reports yet',
    },
    loading: {
        ru: 'Загрузка отчётов',
        en: 'Loading reports',
    },
    error: {
        ru: 'Не удалось загрузить отчёты',
        en: 'Could not load reports',
    },
    generationAccepted: {
        ru: 'Отчёт поставлен в очередь на формирование',
        en: 'Report generation has been queued',
    },
    failures: {
        generic: {
            ru: 'Не удалось сформировать отчёт',
            en: 'Could not generate report',
        },
        queue_failed: {
            ru: 'Не удалось поставить отчёт в очередь',
            en: 'Could not queue report generation',
        },
        generator_unavailable: {
            ru: 'Генератор отчёта недоступен',
            en: 'The report generator is unavailable',
        },
        no_orders: {
            ru: 'В отчёте нет заказов',
            en: 'The report has no orders',
        },
        orders_unavailable: {
            ru: 'Выбранные заказы больше недоступны',
            en: 'The selected orders are no longer available',
        },
        render_failed: {
            ru: 'Не удалось сформировать документ',
            en: 'Could not render the report document',
        },
        storage_failed: {
            ru: 'Не удалось сохранить документ',
            en: 'Could not store the report document',
        },
        persistence_failed: {
            ru: 'Не удалось сохранить состояние отчёта',
            en: 'Could not save the report state',
        },
    },
    download: {
        ru: 'Скачать',
        en: 'Download',
    },
    validation: {
        nameRequired: {
            ru: 'Укажите название отчёта',
            en: 'Enter a report name',
        },
        ordersRequired: {
            ru: 'Выберите хотя бы один заказ',
            en: 'Select at least one order',
        },
    },
    websocketCta: {
        ru: 'Обновить список отчётов',
        en: 'Refresh reports',
    },
    addOrder: {
        ru: 'Добавить заказ',
        en: 'Add order',
    },
    addOrdersFromProject: {
        ru: 'Добавить заказы из проекта',
        en: 'Add orders from project',
    },
    searchOrdersAndProjects: {
        ru: 'Найдите заказ или проект',
        en: 'Search for an order or project',
    },
    searchGroups: {
        orders: {
            ru: 'Заказы',
            en: 'Orders',
        },
        projects: {
            ru: 'Проекты',
            en: 'Projects',
        },
    },
    searchOrder: {
        ru: 'Поиск заказа',
        en: 'Search for an order',
    },
    searchProject: {
        ru: 'Поиск проекта',
        en: 'Search for a project',
    },
    removeOrder: {
        ru: 'Удалить заказ',
        en: 'Remove order',
    },
    projectOrdersAdded: {
        ru: (added: number, total: number) => `добавлено ${added} из ${total}`,
        en: (added: number, total: number) => `${added}/${total} added`,
    },
    reorderOrder: {
        ru: 'Перетащите, чтобы изменить порядок',
        en: 'Drag to reorder',
    },
    generate: {
        ru: 'Сформировать',
        en: 'Generate',
    },
    configurationError: {
        ru: 'Не удалось загрузить настройки генератора',
        en: 'Could not load generator settings',
    },
    generationError: {
        ru: 'Не удалось создать отчёт',
        en: 'Could not create report',
    },
    cancel: {
        ru: 'Отмена',
        en: 'Cancel',
    },
    close: {
        ru: 'Закрыть',
        en: 'Close',
    },
};
